import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { loginSuccess } from '../store/slices/authslice';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const userStr = localStorage.getItem('user');

    if (accessToken && userStr && !isAuthenticated) {
      try {
        const storedUser = JSON.parse(userStr);
        dispatch(loginSuccess({
          id: storedUser.id || storedUser._id,
          name: `${storedUser.firstName || ''} ${storedUser.lastName || ''}`.trim() || 'Admin',
          mobile: storedUser.phoneNumber || '',
          email: storedUser.email || '',
          role: storedUser.role,
        }));
      } catch {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
      }
    }
    setIsLoading(false);
  }, [dispatch, isAuthenticated]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  const hasToken = !!localStorage.getItem('accessToken');
  const storedRole = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}').role; } catch { return null; }
  })();

  if (!hasToken || (!isAuthenticated && !hasToken)) {
    return <Navigate to="/admin/login" replace />;
  }

  const role = user?.role || storedRole;
  if (role && role !== 'admin' && role !== 'superadmin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
